<div class="pb-lg gap-lg grid">
  <p class="text-content-secondary">
    Les {{ traductions().livrable }}s ci-dessous ont été catégorisés au module. Vous pouvez enlever ceux qui ne sont pas
    pertinents pour la séquence. Minimum un livrable caractérisé pour publier.
  </p>

  <div class="gap-xxs grid">
    <label hlmLabel for="select-livrable">{{ traductions().livrable | titlecase }} caractérisé</label>
    <hlm-autocomplete
      id="select-livrable"
      [(search)]="searchLivrable"
      [filteredOptions]="filteredLivrables()"
      (valueChange)="ajouterLivrable($event)"
      autocompleteSearchClass="border-stroke-neutral-medium"
      placeholder="Nom du livrable caractérisé"
    />
  </div>

  @if (module().caracteristiques.length > 0) {
    <app-expansion-panel [titre]="(traductions().livrable | titlecase) + ' générique'">
      <ng-container
        [ngTemplateOutlet]="livrableItem"
        [ngTemplateOutletContext]="{
          items: module().caracteristiques | trierPar: 'nom',
        }"
      />
    </app-expansion-panel>
  }

  @for (item of livrables.value | trierPar: 'nom'; track item.id) {
    <app-expansion-panel [titre]="item.nom" [item]="item" [actions]="livrableActions()">
      <ng-container
        [ngTemplateOutlet]="livrableItem"
        [ngTemplateOutletContext]="{
          items: item.caracteristiques | trierPar: 'nom',
        }"
      />
    </app-expansion-panel>
  }
</div>

<ng-template #livrableItem let-items="items">
  <div class="grid">
    @for (item of items; track item.id; let last = $last) {
      <div class="p-md group/item hover:bg-components-background-neutral-lighter flex items-center justify-between">
        <span class="px-xs component-medium-medium">
          {{ item.nom }}
        </span>
      </div>
      @if (!last) {
        <div hlmItemSeparator></div>
      }
    } @empty {
      <span class="py-md px-lg">Pas de caractéristique pour ce {{ traductions().livrable }}.</span>
    }
  </div>
</ng-template>
